import type { FC } from 'react';

export const LogoutIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_logout)">
      <path
        d="M7.08312 6.66646L8.74979 4.99979M8.74979 4.99979L7.08312 3.33313M8.74979 4.99979H3.7498M5.41646 8.74979H2.58345C2.11675 8.74979 1.88339 8.74979 1.70513 8.65896C1.54833 8.57908 1.42085 8.45158 1.34095 8.29479C1.25012 8.11654 1.25012 7.88317 1.25012 7.41646V2.58313C1.25012 2.11642 1.25012 1.88306 1.34095 1.7048C1.42085 1.548 1.54833 1.42052 1.70513 1.34063C1.88339 1.2498 2.11675 1.2498 2.58345 1.2498H5.41646"
        stroke={props.color || '#E6E6E9'}
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_logout">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
